import { render, staticRenderFns } from "./WorkStationConfiguration.vue?vue&type=template&id=0d8a34c0&"
import script from "./WorkStationConfiguration.vue?vue&type=script&lang=js&"
export * from "./WorkStationConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports